export default __webpack_public_path__ + "static/media/time.7e2400b4.svg";